<template>
  <OppleModal
    class="opple-qa-modal"
    :title="qaData.Q"
    :visible="visible"
    :extend-style="{width: '950px'}"
    :is-show-warn="false"
    :is-show-btn="false"
    @onClose="modalClose"
  >
    <div class="opple-qa-modal_container">
      <div class="opple-qa-modal-guidlist">
        <GuidList :guid="{ DataList: qaData.A }" />
      </div>
      <div
        class="opple-qa-modal_btns"
      >
        <div
          class="opple-qa-modal_btns_lt"
        >
          <div
            class="opple-qa-modal_btns_check"
          >
            <el-checkbox
              v-model="isCheckMain"
            />
            <span>{{ $t('deviceMsg.sureOk') }}</span>
          </div>
          
          <OppleButton
            :disabled="!isCheckMain"
            @click="modalOk"
          >
            {{ $t('deviceMsg.replaceMain') }}
          </OppleButton>
        </div>
        <div
          class="opple-qa-modal_btns_gt"
        >
          <div
            class="opple-qa-modal_btns_check"
          >
            <el-checkbox
              v-model="isCheckSide"
            />
            <span>{{ $t('deviceMsg.sureOk') }}</span>
          </div>
          <OppleButton
            :disabled="!isCheckSide"
            :loading="isRefreshLoading"
            @click="refresh"
          >
            {{ $t('deviceMsg.replaceSlave') }}
          </OppleButton>
        </div>
      </div>
    </div>
  </OppleModal>
</template>
<script>
import OppleButton from '@/components/Base/OppleButton/index.vue';
import OppleModal from '@/components/OppleModal/index.vue'
import GuidList from '@/page/install/device/deviceVirtual/components/GuidList';
import {
  GetHelpQA,
  DeviceConfigRefresh
} from '@/axios/IDevice.js';
import { alertsuccess } from '@/assets/js/common.js'

export default {
  name: 'OppleQaModal',
  components: {
    OppleModal,
    GuidList,
    OppleButton
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    VDeviceId: {
      type: String,
      default: ''
    }
    // qaData: {
    //   type: Array,
    //   default: () => []
    // }
  },
  data () {
    return {
      qaData: {},
      isCheckMain: false,
      isCheckSide: false,
      isRefreshLoading: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.isCheckMain = false;
        this.isCheckSide = false;
      }
    }
  },
  async created () {
  
  },
  mounted () {
    this.requestQa();
  },
  methods: {
    async requestQa() {
      try {
        const lang = this.$store.state.lang;

        const idData = {
          'zh-cn': 220,
          'en-us': 221,
          'de': 222
        }

        const res = await GetHelpQA({ id: idData[lang] || 220 });

        this.qaData = res.Result || {};
      } catch {

      }
    },

    async refresh() {
      this.isRefreshLoading = true
      try {
        const res = await DeviceConfigRefresh({ vDeviceId: this.VDeviceId});

        if (res.StatusCode == this.$store.state.rightStatusCode) {
          alertsuccess(this, res.StatusCode);
        }
      } catch (e) {

      } finally {
        this.isRefreshLoading = false;
      }
    },
    

    async modalClose() {
      this.$emit('close')
    },

    modalOk() {
      this.$emit('ok')
    }
  }
}
</script>

<style lang="scss">
.opple-qa-modal-guidlist {
  .guid-list_text_container {
    width: 100%;
  }

  .guid-list_block {
    width: 100%;
    margin: 0;
  }

  .guid-list_block:nth-child(2) .guid-list_text_container {
    margin-top: 0;
  }
}

.opple-qa-modal {
  &_container {
    width: 100%;
  }

  &_btns {
    display: flex;
    width: 100%;
    align-items: center;

    &_check {
      display: flex;
      align-items: center;

      span {
        margin-left: 10px;
        color: #777;
        font-size: 12px;
      }
    }

    &_lt {
      padding-right: 20px;
      flex: 1;
      display: flex;
      justify-content: space-between;
    }

    &_gt {
      padding-right: 20px;
      flex: 1;
      display: flex;
      justify-content: space-between;
    }

    .opple-button {
      width: 130px;
      font-size: 12px;
    }
  }
}

</style>
